import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AccountOption } from 'src/app/pages/account-register/models/account-option.interface';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { accountOptionSelectors } from '../state/account-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: AccountSelectComponent,
        },
    ],
    selector: 'ndt-account-select',
    templateUrl: './account-select.component.html',
    standalone: false
})
export class AccountSelectComponent extends LcsSingleSelectBase<AccountOption> implements OnInit {
   accounts: Observable<AccountOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.accounts = this.store.pipe(select(accountOptionSelectors.selectFilteredItems), this.itemsLoaded());
   }

   displayWith(item: AccountOption | null): string | null {
      return item ? item.name : null;
   }

   trackBy(item: AccountOption | null) {
      return item ? item.accountId : null;
   }
}
